import type { StoreLocatorFilter } from "@locators/components/PrizeLocator/PrizeLocator.types";

export const getActiveItemIndex = (key: string, activeFilters: StoreLocatorFilter) =>
  activeFilters?.findIndex(({ categoryKey }) => categoryKey === key);
